package org.zest.insan_360_website.pages.user

import org.zest.insan_360_website.data.localized
import org.jetbrains.compose.web.attributes.onSubmit

import androidx.compose.runtime.Composable
import org.zest.insan_360_website.utils.processResponse
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.common.PlaceholderColor
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Form
import org.zest.insan_360_website.components.layouts.*
import org.zest.insan_360_website.components.widgets.DotLoading
import org.zest.insan_360_website.components.widgets.LocalModal
import org.zest.insan_360_website.components.widgets.LocalToast
import org.zest.insan_360_website.data.Language
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.page_states.AuthState.logout
import org.zest.insan_360_website.data.page_states.UserPreferences
import org.zest.insan_360_website.model.ChangePasswordRequest
import org.zest.insan_360_website.utils.NetworkUtils

val settingsContentLayout = CssStyle {
    base {
        Modifier
            .grid {
                columns { size(1.fr) }
                rows { repeat(2) { size(1.fr) } }
            }
    }
    Breakpoint.MD {
        Modifier
            .grid {
                columns { repeat(3) { size(1.fr) } }
                rows { repeat(1) { size(1.fr) } }
            }
    }
    Breakpoint.XL {
        Modifier
            .grid {
                columns { repeat(4) { size(1.fr) } }
                rows { repeat(1) { size(1.fr) } }
            }
    }
}

@OptIn(DelicateApi::class)
@Page
@Layout(".components.layouts.UserDashboardLayout")
@Composable
fun UserSettingsPage() {
    val modal = LocalModal.current

    PageContentBaseCol {
        Div(
            settingsContentLayout.toModifier()
                .gap(1.cssRem)
                .fillMaxWidth()
                .userSelect(UserSelect.None)
                .toAttrs()
        ) {
            PageContentContainer(
                Modifier
                    .padding(1.5.cssRem)
                    .then(containerShadowStyle.toModifier())
            ) {
                Column(
                    modifier = Modifier.fillMaxSize().gap(4.cssRem),
                    verticalArrangement = Arrangement.SpaceBetween
                ) {
                    Column(Modifier.gap(0.5.cssRem).margin(bottom = 1.5.cssRem)) {
                        SpanText(
                            userDashWordLibrary.language_preferences.localized,
                            Modifier.fontWeight(FontWeight.Bold).fontSize(1.5.cssRem)
                        )
                        SpanText(
                            userDashWordLibrary.language_preferences_detail.localized,
                            Modifier.fontSize(1.cssRem)
                        )
                    }

                    Row(
                        Modifier
                            .gap(1.cssRem)
                            .fontSize(1.cssRem)
                            .fillMaxWidth()
                            .justifyContent(JustifyContent.SpaceBetween)
                    ) {
                        val isEn = UserPreferences.language == Language.EN
                        val isBm = UserPreferences.language == Language.BM

                        Box(
                            (if (isEn) contentButtonStyle else neutralContentButtonStyle).toModifier()
                                .flex(1)
                                .padding(leftRight = 1.cssRem, topBottom = 0.5.cssRem)
                                .fillMaxHeight()
                                .onClick { UserPreferences.setLanguage(Language.EN) },
                            contentAlignment = Alignment.Center
                        ) {
                            SpanText(
                                "English",
                                contentButtonTextStyle.toModifier()
                                    .thenIf(!isEn) { Modifier.color(userPageSecondaryTextColor) }
                                    .textAlign(TextAlign.Center)
                            )
                        }

                        Box(
                            (if (isBm) contentButtonStyle else neutralContentButtonStyle).toModifier()
                                .flex(1)
                                .padding(leftRight = 1.cssRem, topBottom = 0.5.cssRem)
                                .fillMaxHeight()
                                .onClick { UserPreferences.setLanguage(Language.BM) },
                            contentAlignment = Alignment.Center
                        ) {
                            SpanText(
                                "Bahasa Melayu",
                                contentButtonTextStyle.toModifier()
                                    .thenIf(!isBm) { Modifier.color(userPageSecondaryTextColor) }
                                    .textAlign(TextAlign.Center)
                            )
                        }
                    }
                }
            }
            PageContentContainer(
                Modifier
                    .fillMaxSize()
                    .padding(1.5.cssRem)
                    .then(containerShadowStyle.toModifier())
            ) {
                Column(
                    modifier = Modifier.fillMaxSize(),
                    verticalArrangement = Arrangement.SpaceBetween
                ) {
                    Column(Modifier.gap(0.5.cssRem).margin(bottom = 1.5.cssRem)) {
                        SpanText(
                            userDashWordLibrary.account_security.localized,
                            Modifier
                                .fontWeight(FontWeight.Bold)
                                .fontSize(1.5.cssRem)
                        )
                        SpanText(
                            userDashWordLibrary.account_security_detail.localized,
                            Modifier.fontSize(1.cssRem)
                        )
                    }

                    Row(
                        Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.End
                    ) {
                        Box(
                            contentRedButtonStyle.toModifier()
                                .padding(leftRight = 1.25.cssRem, topBottom = 0.75.cssRem)
                                .onClick {
                                    modal.show(Modifier.fontSize(1.cssRem)) {
                                        LogoutModal()
                                    }
                                }
                        ) {
                            SpanText(
                                userDashWordLibrary.logout.localized,
                                contentButtonTextStyle.toModifier()
                            )
                        }
                    }
                }
            }
        }
        ChangePasswordSection()
    }
}

@Composable
fun ChangePasswordSection() {
    val toast = LocalToast.current
    val scope = rememberCoroutineScope()
    val authWordLibrary = LanguageSettings.AuthenticationPage
    val modal = LocalModal.current

    var currentPassword by remember { mutableStateOf("") }
    var newPassword by remember { mutableStateOf("") }
    var confirmPassword by remember { mutableStateOf("") }
    var isProcessing by remember { mutableStateOf(false) }

    PageContentContainer(
        Modifier
            .fillMaxSize()
            .padding(1.5.cssRem)
            .then(containerShadowStyle.toModifier())
    ) {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            Column(Modifier.gap(0.5.cssRem).margin(bottom = 1.cssRem)) {
                SpanText(
                    authWordLibrary.changePassword.localized,
                    Modifier.fontWeight(FontWeight.Bold).fontSize(1.5.cssRem)
                )
            }

            Form(
                attrs = Modifier.fillMaxWidth().toAttrs {
                    onSubmit { it.preventDefault() }
                }
            ) {
                Column(Modifier.fillMaxWidth().gap(1.cssRem)) {
                    Input(
                        modifier = baseInputStyle.toModifier(),
                        focusBorderColor = lightGreenColor,
                        placeholderColor = PlaceholderColor(lightGreenColor),
                        type = InputType.Password,
                        value = currentPassword,
                        onValueChange = { currentPassword = it },
                        placeholder = authWordLibrary.currentPassword.localized
                    )
                    Input(
                        modifier = baseInputStyle.toModifier(),
                        focusBorderColor = lightGreenColor,
                        placeholderColor = PlaceholderColor(lightGreenColor),
                        type = InputType.Password,
                        value = newPassword,
                        onValueChange = { newPassword = it },
                        placeholder = authWordLibrary.newPassword.localized
                    )
                    Input(
                        modifier = baseInputStyle.toModifier(),
                        focusBorderColor = lightGreenColor,
                        placeholderColor = PlaceholderColor(lightGreenColor),
                        type = InputType.Password,
                        value = confirmPassword,
                        onValueChange = { confirmPassword = it },
                        placeholder = authWordLibrary.confirmPassword.localized
                    )

                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
                        Button(
                            enabled = !isProcessing,
                            onClick = submitLogic@ {
                                if (currentPassword.isBlank() || newPassword.isBlank()) {
                                    toast.show(authWordLibrary.fillAllRequiredFields.localized)
                                    return@submitLogic
                                }
                                if (!newPassword.matches(Regex("^(?=.*[A-Z])(?=.*\\d).{8,}$"))) {
                                    toast.show(authWordLibrary.passwordComplexError.localized)
                                    return@submitLogic
                                }
                                if (newPassword != confirmPassword) {
                                    toast.show(authWordLibrary.passwordConfirmation.localized)
                                    return@submitLogic
                                }
                                isProcessing = true
                                scope.launch {
                                    try {
                                        val response = NetworkUtils.postSecureApi(
                                            "/api/auth/change-password",
                                            ChangePasswordRequest(currentPassword, newPassword)
                                        )
                                        if (response != null) {
                                            processResponse<Unit>(
                                                response = response,
                                                toast = toast,
                                                fallbackErrorLog = "Failed to change password"
                                            ) {
                                                logout(modal, toast)
                                            }
                                        }
                                    } catch (_: Exception) {
                                        toast.show(LanguageSettings.General.networkFailure.localized)
                                    } finally {
                                        isProcessing = false
                                    }
                                }
                            },
                            modifier = buttonColorStyle.toModifier().padding(leftRight = 1.25.cssRem, topBottom = 0.75.cssRem)
                        ) {
                            if (isProcessing) {
                                DotLoading(Colors.White)
                            } else {
                                SpanText(
                                    authWordLibrary.updatePassword.localized,
                                    contentButtonTextStyle.toModifier()
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}
@Composable
fun LogoutModal() {
    val modal = LocalModal.current
    val toast = LocalToast.current
    val scope = rememberCoroutineScope()
    var isProcessing by remember { mutableStateOf(false) }

    Column(Modifier.gap(1.5.cssRem).userSelect(UserSelect.None)) {
        Box(
            Modifier.fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            SpanText(
                LanguageSettings.UserDashboardPage.LogoutModal.title.localized,
                Modifier.fontWeight(FontWeight.Bold)
            )
        }

        Row(
            Modifier
                .justifyContent(JustifyContent.SpaceBetween)
                .fillMaxWidth()
                .gap(1.cssRem),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(
                neutralContentButtonStyle.toModifier()
                    .flex(1)
                    .fillMaxSize()
                    .backgroundColor(userPageBorderStrongColor)
                    .padding(leftRight = 1.cssRem, topBottom = 0.5.cssRem)
                    .thenIf(!isProcessing) { Modifier.onClick { modal.hide() } }
            ) {
                SpanText(
                    LanguageSettings.UserDashboardPage.LogoutModal.cancel.localized,
                    contentButtonTextStyle.toModifier()
                        .textAlign(TextAlign.Center)
                        .color(userPageSecondaryTextColor)
                        .fillMaxSize()
                )
            }

            Box(
                contentRedButtonStyle.toModifier()
                    .flex(1)
                    .fillMaxSize()
                    .padding(leftRight = 1.cssRem, topBottom = 0.5.cssRem)
                    .thenIf(isProcessing) { Modifier.opacity(0.5) }
                    .thenIf(!isProcessing) {
                        Modifier.onClick {
                            isProcessing = true
                            scope.launch {
                                try {
                                    logout(modal, toast)
                                } finally {
                                    isProcessing = false
                                }
                            }
                        }
                    }
            ) {
                SpanText(
                    if (isProcessing) "Logging out..."
                    else LanguageSettings.UserDashboardPage.LogoutModal.yes.localized,
                    contentButtonTextStyle.toModifier()
                        .textAlign(TextAlign.Center)
                        .fillMaxSize()
                )
            }
        }
    }
}